import { render, staticRenderFns } from "./StoreLocatorConfigBasic.vue?vue&type=template&id=2cab8ee1&scoped=true&"
import script from "./StoreLocatorConfigBasic.vue?vue&type=script&lang=js&"
export * from "./StoreLocatorConfigBasic.vue?vue&type=script&lang=js&"
import style0 from "./StoreLocatorConfigBasic.vue?vue&type=style&index=0&id=2cab8ee1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cab8ee1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
